var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isEidt
    ? _c("el-checkbox", {
        attrs: { "true-label": _vm.trueLabel, "false-label": _vm.falseLable },
        on: { change: _vm.onChange },
        model: {
          value: _vm.params.data[_vm.field],
          callback: function($$v) {
            _vm.$set(_vm.params.data, _vm.field, $$v)
          },
          expression: "params.data[field]"
        }
      })
    : _c("span", [
        _vm._v(_vm._s(_vm.disabledFormatter(_vm.params.data[_vm.field])))
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }